import { styled } from "styled-components";
import { Button, Checkbox, Table, TableContainer, TablePagination, TableRow } from "@mui/material";

export const TableWrapper = styled(TableContainer)`
	border-radius: 10px;
	border: 1px solid #b8c8cf;
	overflow: hidden;
`;

export const TableToolbar = styled.div`
	display: flex;
	justify-content: ${(props) => (props.display ? "flex-end" : "space-between")};
	align-items: center;
	padding: 0 22px 20px;
	margin-top: ${(props) => (props.display ? "1.5rem" : "0px")};

	._notification {
		font-size: 15px;
		font-weight: 500;

		&::before {
			content: "";
			display: inline-block;
			width: 10px;
			height: 10px;
			background: #1d86b3;
			border-radius: 50%;
			margin-right: 8px;
		}
	}

	._buttons {
		display: flex;
		align-items: center;
		gap: 18px;

		img {
			padding: 0 6px;
			transform: scale(0.85);
		}
		button {
			border-radius: 5px;
			padding: 6px 18px;
		}
	}

	.toolbarSelect {
		.MuiSelect-select {
			color: #333333;
			padding: 6px 18px;
			padding-right: 38px !important;
		}
	}
`;

export const StyledTable = styled(Table)`
	th,
	td {
		color: #555;
		font-weight: 400;
		font-family: "Manrope", sans-serif;
	}

	/* th,
	td {
		padding: 16px 12px;
		padding-left: 0;
	} */
	/* th and td not: first-child */

	th:not(:first-child),
	td:not(:first-child) {
		padding: 16px 13px;
	}

	th {
		color: #333;
		font-weight: 500;
		font-size: 10px;
		line-height: 1.25rem;
		text-transform: uppercase;
	}
	td {
		text-transform: capitalize;
		font-size: 13px;
	}

	&:last-child td,
	&:last-child th {
		border-bottom: none;
	}

	.MuiTableSortLabel-icon {
		left: 7px;
		position: relative;
		opacity: 0.18;
	}

	/* Media Query - Responsive font size */
	@media (min-width: 1366px) {
		th {
			font-size: 0.6875rem;
		}
		td {
			font-size: 0.8125rem;
		}
	}
	@media (min-width: 1680px) {
		th {
			font-size: 0.8125rem;
		}
		td {
			font-size: 0.9063rem;
		}
	}
`;

export const StyledTableRow = styled(TableRow)`
	cursor: pointer;
	border-bottom: 1px solid rgba(153, 153, 153, 0.3);

	&.Mui-selected {
		th,
		td {
			color: #333;
			font-weight: 500;
		}
	}

	/* &.MuiTableRow-hover:hover {
	} */

	.no_data_found {
		font-weight: 500;
		padding: 22px;
	}

	.badge {
		color: #333333;
		font-size: 12px;
		padding: 4px 12px;
		text-transform: uppercase;
		border-radius: 5px;
		background: rgba(255, 188, 188, 0.3);

		&.fixed,
		&.released,
		&.completed,
		&.approved,
		&.overdue,
		&.success {
			background: rgba(0, 174, 38, 0.2);
		}
		&.active {
			background: #cfebed;
		}
		&.returned {
			background: #ffebeb;
		}
		&.warning,
		&.pending {
			background: #f9ffae;
		}
		&.bad {
			background: rgba(255, 164, 99, 0.8);
		}
		&.complete {
			background: #ccf3dc;
		}
		&.idle {
			background: #ccd5dd;
		}
		&.incomplete {
			background: #fff4cc;
		}
		&.inactive {
			background: #e2b3ff;
		}
		&.deactivated {
			background: #ebebeb;
		}
		&.flagged {
			background: #fcd9d9;
		}
	}
`;

export const StyledCheckbox = styled(Checkbox)`
	.MuiSvgIcon-root {
		fill: #999;
	}
`;

export const TableButton = styled(Button)`
	color: #006770 !important;
	border: 1px solid #b8c8cf !important;
	font-size: 12px !important;
	display: ${(props) => (props.display ? "flex" : "")};
	gap: ${(props) => (props.display ? ".8rem" : "")};
	align-items: ${(props) => (props.display ? "center" : "")};
	text-transform: lowercase;
	/* justify-content: flex-end; */

	select {
		font-size: 14px !important;
		outline: none;
		border: none;
		height: 100%;
	}
`;

export const StyledTablePagination = styled(TablePagination)`
	display: flex;
	margin-top: 18px;

	&,
	p {
		font-size: 14px;
		text-transform: capitalize;
		color: #333333;
	}

	.MuiInputBase-colorPrimary {
		border: 1px solid #b8c8cf;
		border-radius: 5px;
	}

	.MuiTablePagination-actions {
		display: flex;
		align-items: center;
		gap: 18px;

		& > button {
			color: #006770 !important;
			border: 1px solid #b8c8cf !important;
			border-radius: 5px !important;
			padding: 4px 14px !important;

			&.Mui-disabled {
				color: #999 !important;
				border: 1px solid #999 !important;
			}
		}
	}
`;
